<!-- 单项选择题 -->
<template>
  <div class="topic_choice">
    <div class="flex topic_select">
      <div class="topic_type">{{ topicInfo.questionTypeName }}</div>
      <div class="topic_content flex-1 mar_left_10">
        <div class="flex topic_content_top FlexBetween">
          <div class="topic_title flex-1" v-html="topicInfo?.questionTitle" v-mathml></div>
          <div class="flex Flexalign Flexjustify analysis_text cursor_pointer" @click="changeIsShowAnalysis()">
            <div>查看解析</div>
            <el-image class="arrow_down_active mar_left_5" :src="iconPath('arrow_up_active.png')"
              v-if="topicInfo.isShowAnalysis"></el-image>
            <el-image class="arrow_down_active mar_left_5" :src="iconPath('arrow_down_active.png')" v-else></el-image>
          </div>
        </div>
        <div class="flex Flexalign mt-15" v-if="topicInfo.otherRule">
          <div class="mr-10">音频：</div><audio :src="getAudioUrl(topicInfo.otherRule)" controls></audio>
        </div>
        <div>
          <el-checkbox-group v-model="topicInfo.selectedValue" @change="changeAnswer">
            <el-checkbox v-for="(item, index) in topicInfo.questionContext?.options" :key="index"
              :value="item.serial.toString()" size="large" :disabled="true">
              <div class="flex FlexBaseline">
                <div>{{ item.label }} .</div>
                <div class="editor_box" v-html="$Tools.handlerImg(item.content)" v-mathml></div>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="mar_top_20 analysis_box" v-if="topicInfo.isShowAnalysis">
      <div class="question_analyze mar_top_10">【试题分析】</div>
      <div class="mar_top_10 scroll_x" v-html="topicInfo.questionAnalyze" v-mathml></div>
      <div class="question_analyze mar_top_10">【解析】</div>
      <div class="mar_top_10 scroll_x" v-html="topicInfo.abilityName" v-mathml></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5Choice",
  props: {
    questionInfo: {},
  },
  computed: {
    ...mapState({
      testExamTime: (state) => state.exam.testExamTime,
    }),
  },

  data() {
    return {
      topicInfo: {},
    };
  },
  watch: {
    questionInfo: {
      handler(val) {
        if (val) {
          this.topicInfo = val;
          console.log(this.topicInfo, 99999);
          // 多选题答案为数组,将正确答案也变为数组
          //   if (this.$Tools.empty(this.topicInfo.selectedValue)) {
          //     this.topicInfo.selectedValue = [];
          //     // 判断是不是数组，不是数组转换
          //     if (!Array.isArray(this.topicInfo.questionContext?.answer)) {
          //       this.topicInfo.questionContext.answer = this.topicInfo.questionContext?.answer?.split(
          //         ","
          //       );
          //     }
          //   }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() { },

  methods: {
    getAudioUrl(info) {
      let ruleInfo = this.$Tools.jsonDecode(info);
      if (!this.$Tools.empty(ruleInfo)) {
        return ruleInfo.listeningRule?.audioUrl
      }
    },
    changeAnswer(value) {
      // console.log(this.topicInfo.selectedValue);
      // console.log(this.topicInfo.questionContext?.answer);
      // console.log(this.areArraysEqual(value, this.topicInfo.questionContext?.answer))
      if (this.areArraysEqual(value, this.topicInfo.questionContext?.answer)) {
        this.topicInfo.isCorrect = 1;
      } else {
        this.topicInfo.isCorrect = 2;
      }
      this.topicInfo.questionScore =
        this.topicInfo.isCorrect == 1 ? this.topicInfo.questionContext.score : 0; // 得分
      this.topicInfo.questionContext.selectedValue = this.topicInfo.selectedValue.join(
        ","
      ); // 保存答案
      this.$emit("answerQuestion", this.topicInfo);
    },
    // 判断数组是否相同（内容）
    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      // 类型归一化函数（仅转换字符串数字）
      const normalize = (item) => {
        if (typeof item === "string") {
          const num = Number(item);
          return isNaN(num) ? item : num; // 非数字字符串保留原样
        }
        return item;
      };

      // 归一化后排序
      const sortedArr1 = [...arr1].map(normalize).sort((a, b) => a - b);
      const sortedArr2 = [...arr2].map(normalize).sort((a, b) => a - b);

      // 严格比较（支持 NaN）
      return sortedArr1.every((elem, index) => Object.is(elem, sortedArr2[index]));
    },
    changeIsShowAnalysis() {
      this.topicInfo.isShowAnalysis = !this.topicInfo.isShowAnalysis;
    },
  },
};
</script>

<style lang="scss" scoped>
.topic_select {
  .topic_type {
    // margin-top: 1rem;
    width: 45px;
    height: 21px;
    background: rgba(0, 199, 88, 0.2);
    border-radius: 4px;
    border: 1px solid #00c758;
    line-height: 21px;
    text-align: center;
    font-size: 12px;
    color: #00c758;
  }

  .topic_content {

    // overflow-x: auto;
    .topic_content_top {
      width: 100%;
      // height: 32px;
    }

    .topic_title {
      font-size: 16px;
      color: #242324;
      font-weight: 600;
    }

    .arrow_down_active {
      width: 18px;
      height: 18px;
    }

    .analysis_text {
      width: 110px;
      height: 32px;
      border-radius: 16px;
      border: 1px solid #13d6aa;
      color: #13d6aa;
      line-height: 32px;
      margin-top: 1rem;
    }

    .editor_box {
      white-space: normal;
    }
  }
}

.bottom_box {
  position: absolute;
  left: calc(50% - 60px);
  bottom: 40px;
  text-align: center;

  .btn_view {
    width: 120px;
    height: 42px;
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-radius: 21px;
    text-align: center;
    line-height: 42px;
    color: #fff;
    font-size: 18px;
  }

  .view_analysis {
    color: #13d6aa;
  }
}

.topic_answer {
  width: 100%;
  // height: 222px;
  background: rgba(19, 214, 170, 0.05);
  border-radius: 10px;
  padding: 20px;
  color: #666666;
  box-sizing: border-box;

  .answer_top {
    .correct_value_answer {
      color: RGBA(0, 199, 88, 1);
    }

    .error_value_answer {
      color: RGBA(255, 49, 49, 1);
    }

    .btn_ask {
      width: 64px;
      height: 28px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 14px;
      line-height: 28px;
      text-align: center;
      color: #fff;
    }
  }

  .question_analyze {
    color: #333333;
    font-weight: 600;
  }
}

.analysis_box {
  padding: 20px 25px;
  background: rgba(19, 214, 170, 0.05);
  border-radius: 10px;
  overflow: auto;
}

:deep(.el-checkbox.el-checkbox--large) {
  display: flex;
  align-items: baseline;
  min-height: 36px;
  height: auto;
}

:deep(.el-checkbox__label) {
  line-height: normal;
}
</style>
